import React, { useState, useEffect } from 'react';
import { SuccessCircle, WarningIcon } from '../../assets/icons';
import Spinner from '../common/Spinner';
import useModalClose from '../../hooks/useModalClose';
import { sendAnswer } from "../../services/requestService"; // dosya yolu sizde farklıysa düzeltin

const STEPS = {
  FORM: 0,
  CONFIRM: 1,
  COMPLETE: 2
};

const SendAnswerModal = ({ isOpen, onClose, onSuccess, selectedRequestId  }) => {
  const [currentStep, setCurrentStep] = useState(STEPS.FORM);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({
    text: '',
    image: null
  });
  const [previewImage, setPreviewImage] = useState(null);
  const [submittedData, setSubmittedData] = useState(null);
  useEffect(() => {
    if (isOpen) {
      console.log("Modal açıldı. Gelen request ID:", selectedRequestId);
    }
  }, [isOpen, selectedRequestId]);
  useEffect(() => {
    if (!isOpen) {
      setCurrentStep(STEPS.FORM);
      setIsLoading(false);
      setError(null);
      setFormData({ text: '', image: null });
      setPreviewImage(null);
      setSubmittedData(null);
    }
  }, [isOpen]);

  const handleClose = () => {
    setCurrentStep(STEPS.FORM);
    setIsLoading(false);
    setError(null);
    setFormData({ text: '', image: null });
    setPreviewImage(null);
    setSubmittedData(null);
    onClose();
  };

  const handleTextChange = (e) => {
    setFormData(prev => ({
      ...prev,
      text: e.target.value
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        setError('Resim boyutu 5MB\'dan büyük olamaz.');
        return;
      }
      setFormData(prev => ({
        ...prev,
        image: file
      }));
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const validateForm = () => {
    if (!formData.text.trim()) {
      setError('Lütfen cevap alanını doldurunuz.');
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);
    
    if (validateForm()) {
      setCurrentStep(STEPS.CONFIRM);
    }
  };

  const handleBack = () => {
    setCurrentStep(STEPS.FORM);
  };

  const handleConfirm = async () => {
    setIsLoading(true);
    setError(null);
  
    try {
      // API çağrısı
      await sendAnswer(selectedRequestId, {
        text: formData.text,
        image: formData.image
      });
  
      // Başarılıysa:
      setSubmittedData({
        text: formData.text,
        imageUrl: previewImage
      });
      setCurrentStep(STEPS.COMPLETE);
      onSuccess();            // üst bileşene bildir
    } catch (err) {
      setError("Gönderim sırasında bir hata oluştu.");
      console.error(err);
      setCurrentStep(STEPS.COMPLETE);
    } finally {
      setIsLoading(false);
    }
  };
  const renderStepIndicator = () => (
    <div className="stepper flex justify-between mb-6">
      <div className={`step flex flex-col items-center ${currentStep >= STEPS.FORM ? 'active' : ''}`}>
        <div className="step-circle w-8 h-8 rounded-full border-2 border-gray-300 flex items-center justify-center">
          {currentStep >= STEPS.FORM && <div className='step-active-circle w-5 h-5 bg-blue-500 rounded-full'/>}
        </div>
        <span className="step-title text-sm mt-2">Bilgi Girişi</span>
      </div>
      <div className={`step flex flex-col items-center ${currentStep >= STEPS.CONFIRM ? 'active' : ''}`}>
        <div className="step-circle w-8 h-8 rounded-full border-2 border-gray-300 flex items-center justify-center">
          {currentStep >= STEPS.CONFIRM && <div className='step-active-circle w-5 h-5 bg-blue-500 rounded-full'/>}
        </div>
        <span className="step-title text-sm mt-2">Bilgi Onayı</span>
      </div>
      <div className={`step flex flex-col items-center ${currentStep >= STEPS.COMPLETE ? 'active' : ''}`}>
        <div className="step-circle w-8 h-8 rounded-full border-2 border-gray-300 flex items-center justify-center">
          {currentStep >= STEPS.COMPLETE && <div className='step-active-circle w-5 h-5 bg-blue-500 rounded-full'/>}
        </div>
        <span className="step-title text-sm mt-2">Tamamlandı</span>
      </div>
    </div>
  );

  const renderForm = () => (
    <div className="create-response-form">
      <div className="form-group mb-4">
        <label htmlFor="text" className="block text-sm font-medium text-gray-700 mb-1">Cevap</label>
        <textarea
        style={{ width: "100%", height: "120px" }}
          id="text"
          name="text" maxLength={3000}
          value={formData.text}
          onChange={handleTextChange}
          placeholder="Cevabınızı buraya yazın..."
          className="w-full h-32 p-2 border border-gray-300 rounded-md resize-y form-control"
        />
      </div>
      <div className="form-group mb-4">
        <label htmlFor="image" className="block text-sm font-medium text-gray-700 mb-1">Resim Yükle</label>
        <input
          type="file"
          id="image"
          name="image"
          accept="image/*"
          onChange={handleImageChange}
          className="w-full p-2 border border-gray-300 rounded-md"
        />
        {previewImage && (
          <div className="mt-2">
            <img style={{ width: "120px"}} src={previewImage} alt="Preview" className="max-w-xs h-auto rounded-md" />
          </div>
        )}
      </div>
      {error && <div className="error-message text-red-500 mb-4">{error}</div>}
      <div className="form-actions">
        <button type="button" onClick={handleSubmit} className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600">
          Gönder
        </button>
      </div>
    </div>
  );

  const renderConfirmation = () => (
    <div className="confirmation-step">
      <WarningIcon />
      <h3 className="text-lg font-semibold mb-4">Bilgileri göndermek üzeresiniz. Onaylıyor musunuz?</h3>
      <div className="table-container mb-4">
        <table className="users-table w-full border-collapse">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2 text-left">Cevap</th>
              <th className="border p-2 text-left">Resim</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border p-2">{formData.text}</td>
              <td className="border p-2">
                {previewImage ? (
                  <img  style={{ width: "120px"}} src={previewImage} alt="Preview" className="max-w-xs h-auto rounded-md" />
                ) : 'Resim yüklenmedi'}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="form-actions flex gap-2">
        <button type="button" onClick={handleBack} className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400">
          İptal Et
        </button>
        <button type="button" onClick={handleConfirm} className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600">
          Onayla
        </button>
      </div>
    </div>
  );

  const renderComplete = () => (
    <div className="complete-step">
      {isLoading ? (
        <div className="loading-state flex flex-col items-center">
          <Spinner size="large" />
          <h3 className="text-lg font-semibold mt-4">Süreciniz tamamlanıyor...</h3>
          <button type="button" onClick={handleClose} className="bg-red-500 text-white px-4 py-2 rounded-md mt-4 hover:bg-red-600">
            Süreci İptal Et
          </button>
        </div>
      ) : submittedData ? (
        <div className="success-state flex flex-col items-center">
          <SuccessCircle />
          <h3 className="text-lg font-semibold mt-4">Süreciniz tamamlandı. Cevap gönderildi.</h3>
          <div className="table-container mt-4 w-full">
            <table className="users-table w-full border-collapse">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border p-2 text-left">Cevap</th>
                  <th className="border p-2 text-left">Resim</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border p-2">{submittedData.text}</td>
                  <td className="border p-2">
                    {submittedData.imageUrl ? (
                      <img src={submittedData.imageUrl} alt="Submitted" className="max-w-xs h-auto rounded-md" />
                    ) : 'Resim yüklenmedi'}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <button type="button" onClick={handleClose} className="bg-blue-500 text-white px-4 py-2 rounded-md mt-4 hover:bg-blue-600">
            Kapat
          </button>
        </div>
      ) : (
        <div className="error-state flex flex-col items-center">
          <div className="error-icon text-red-500 text-4xl">✕</div>
          <h3 className="text-lg font-semibold mt-4">Hata Oluştu</h3>
          <p className="text-red-500">{error}</p>
          <button type="button" onClick={handleBack} className="bg-blue-500 text-white px-4 py-2 rounded-md mt-4 hover:bg-blue-600">
            Tekrar Dene
          </button>
        </div>
      )}
    </div>
  );

  useModalClose(isOpen, onClose);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="modal-content bg-white rounded-lg p-6 max-w-2xl w-full">
        <div className="modal-header mb-4">
          <h3 className="text-xl font-semibold">Cevap Gönder</h3>
        </div>
        {renderStepIndicator()}
        <div className="modal-body">
          {currentStep === STEPS.FORM && renderForm()}
          {currentStep === STEPS.CONFIRM && renderConfirmation()}
          {currentStep === STEPS.COMPLETE && renderComplete()}
        </div>
      </div>
    </div>
  );
};

export default SendAnswerModal;